import { render, staticRenderFns } from "./JSelectZyb.vue?vue&type=template&id=36a6a50c&scoped=true"
import script from "./JSelectZyb.vue?vue&type=script&lang=js"
export * from "./JSelectZyb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6a50c",
  null
  
)

export default component.exports